import { Section } from "@/components/common/Section";
import { Container } from "@/components/common/Container";
import { Reveal } from "@/components/common/Reveal";
import { CtaButton } from "@/components/common/CtaButton";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { faqs } from "@/data/faq.data";
import { siteConfig } from "@/config/site.config";

/** FAQ — accessible accordion (Radix: full keyboard + ARIA support). */
export function Faq() {
  return (
    <Section id="faq" className="bg-card/40">
      <Container>
        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <Reveal>
              <span className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-3.5 py-1.5 text-xs font-medium uppercase tracking-[0.14em] text-primary">
                <span className="h-1.5 w-1.5 rounded-full bg-accent" />
                FAQ
              </span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 font-heading text-3xl font-bold leading-[1.1] tracking-tight text-foreground sm:text-4xl">
                Questions, answered.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-5 max-w-sm text-muted-foreground">
                Still curious? Book a free consultation and we&apos;ll answer
                anything specific to your project.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-7">
                <CtaButton to={siteConfig.primaryCta.path} withArrow magnetic>
                  {siteConfig.primaryCta.label}
                </CtaButton>
              </div>
            </Reveal>
          </div>

          <Reveal>
            <Accordion
              type="single"
              collapsible
              defaultValue="item-0"
              className="w-full"
              data-testid="faq-accordion"
            >
              {faqs.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-border"
                >
                  <AccordionTrigger className="py-5 text-left font-heading text-base font-semibold text-foreground hover:no-underline data-[state=open]:text-primary">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-[15px] leading-relaxed text-muted-foreground">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </Container>
    </Section>
  );
}
